export default __webpack_public_path__ + "static/media/Group8883.ade58ea0.svg";